import React, { useMemo, useState } from "react";
import styles from "./Detail.module.scss";
import classNames from "classnames/bind";
import SocialSection from "./components/SocialSection";
import DigitalAdsSection from "./components/DigitalAdsSection";
import OTASection from "./components/OTASection";

const cx = classNames.bind(styles);

const periodLabel = (from, to) => `${from} - ${to}`;

const Detail = () => {
  const [open, setOpen] = useState(false);
  const [range, setRange] = useState("this_month");
  const [showCustom, setShowCustom] = useState(false);
  const [customSince, setCustomSince] = useState(""); // YYYY-MM-DD (draft)
  const [customUntil, setCustomUntil] = useState(""); // YYYY-MM-DD (draft)
  const [appliedRange, setAppliedRange] = useState({ key: "this_month" });

  const toISO = (d) => {
    const y = d.getFullYear();
    const m = String(d.getMonth() + 1).padStart(2, "0");
    const day = String(d.getDate()).padStart(2, "0");
    return `${y}-${m}-${day}`;
  };
  const toVN = (d) => {
    const day = String(d.getDate()).padStart(2, "0");
    const m = String(d.getMonth() + 1).padStart(2, "0");
    const y = d.getFullYear();
    return `${day}/${m}/${y}`;
  };
  const calcRange = (key, sinceStr, untilStr) => {
    const now = new Date();
    let start;
    if (key === "this_week") {
      const day = now.getDay();
      const diff = (day === 0 ? 6 : day - 1); // Monday start
      start = new Date(now.getFullYear(), now.getMonth(), now.getDate() - diff);
    } else {
      start = new Date(now.getFullYear(), now.getMonth(), 1);
    }
    start.setHours(0, 0, 0, 0);
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    if (key === "custom" && sinceStr && untilStr) {
      const s = new Date(sinceStr);
      const u = new Date(untilStr);
      return { since: toVN(s), until: toVN(u) };
    }
    return { since: toVN(start), until: toVN(today) };
  };
  const curLabel = useMemo(
    () => calcRange(appliedRange.key, appliedRange.since, appliedRange.until),
    [appliedRange]
  );
  const [from, to] = [curLabel.since, curLabel.until];

  const getApiRange = (key, sinceStr, untilStr) => {
    const now = new Date();
    let start;
    if (key === "this_week") {
      const day = now.getDay();
      const diff = (day === 0 ? 6 : day - 1);
      start = new Date(now.getFullYear(), now.getMonth(), now.getDate() - diff);
    } else {
      start = new Date(now.getFullYear(), now.getMonth(), 1);
    }
    start.setHours(0, 0, 0, 0);
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    if (key === "custom" && sinceStr && untilStr) {
      const s = new Date(sinceStr);
      const u = new Date(untilStr);
      return {
        fb: { since: toISO(s), until: toISO(u) },
        tk: { since: toVN(s), until: toVN(u) },
      };
    }
    return {
      fb: { since: toISO(start), until: toISO(today) },
      tk: { since: toVN(start), until: toVN(today) },
    };
  };
  const curRange = useMemo(
    () => getApiRange(appliedRange.key, appliedRange.since, appliedRange.until),
    [appliedRange]
  );

  const options = [
    { value: "this_week", label: "Tuần này" },
    { value: "this_month", label: "Tháng này" },
    { value: "custom", label: "Tùy chọn" },
  ];
  const selectedLabel = options.find((o) => o.value === (showCustom ? "custom" : appliedRange.key))?.label || "";

  const handleSelect = (val) => {
    if (val === "custom") {
      // Mở panel tùy chọn và ẩn menu như bên Home
      setRange("custom");
      setShowCustom(true);
      setOpen(false);
      return;
    }
    // Áp dụng nhanh các mốc có sẵn và đóng menu
    setAppliedRange({ key: val });
    setRange(val);
    setShowCustom(false);
    setOpen(false);
  };
  const applyCustom = () => {
    if (customSince && customUntil) {
      setAppliedRange({ key: "custom", since: customSince, until: customUntil });
      setRange("custom");
      setShowCustom(false);
      setOpen(false);
    }
  };
  const cancelCustom = () => {
    setShowCustom(false);
    setOpen(false);
    // Revert selection label to last applied
    setRange(appliedRange.key);
  };

  return (
    <main className={cx("main")}>
      <div className={cx("sectionHeader")}>
        <div className={cx("phantom")} />
        <div className={cx("dropdown")}> 
        <button
          type="button"
          className={cx("dropdownToggle")}
          onClick={() => setOpen(!open)}
        >
          {selectedLabel}
          <span className={cx("arrow")}>↕</span>
        </button>
        {open && (
          <ul className={cx("dropdownMenu")}>
            {options.map((opt) => (
              <li key={opt.value} onClick={() => handleSelect(opt.value)}>
                {opt.label}
              </li>
            ))}
          </ul>
        )}
        {showCustom && (
          <div className={cx("customPanel")}> 
            <span className={cx("label")}>Từ</span>
            <input type="date" value={customSince} onChange={(e) => setCustomSince(e.target.value)} />
            <span className={cx("sep")}>→</span>
            <span className={cx("label")}>Đến</span>
            <input type="date" value={customUntil} onChange={(e) => setCustomUntil(e.target.value)} />
            <div className={cx("actions")}> 
              <button className={cx("btn")} onClick={cancelCustom}>Huỷ</button>
              <button className={cx("btn", "primary")} onClick={applyCustom}>Áp dụng</button>
            </div>
          </div>
        )}
        </div>
      </div>

      <SocialSection period={periodLabel(from, to)} curRange={curRange} />
      {/* <DigitalAdsSection period={periodLabel(from, to)} />
      <OTASection period={periodLabel(from, to)} /> */}
    </main>
  );
};

export default Detail;
